<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<tableList v-show="activeTab === '1'" @click-card="clickCard"></tableList>
			<notificationInfo v-if="activeTab === '2'" :param="param"></notificationInfo>
		</topTab>
	</div>
</template>

<script>
import tableList from "./tableList.vue";
import notificationInfo from "./detail.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "公告列表"
				},
				{
					key: "2",
					value: "公告详情",
					isPush: true,
					isHide: true
				}
			],
			param: {
				row: {}
			}
		};
	},
	// 注册组件
	components: {
		tableList,
		notificationInfo
	},
	created() {},
	watch: {},
	computed: {},
	methods: {
		// 顶部tab页面切换
		changePages(tab) {
			this.activeTab = tab;
			switch (tab) {
				case "1":
					this.tabData[1].isHide = true;
					break;
				default:
					break;
			}
			this.$refs.topTab.showTopTab(this.tabData);
		},
		// 点击单项
		clickCard(item, index) {
			switch (index) {
				case 1:
					this.param.row = item;
					break;
				default:
					break;
			}
			this.clickTab(index);
		},
		clickTab(index) {
			this.tabData[index].isHide = false;
			this.$refs.topTab.showTopTab(this.tabData);
			this.$refs.topTab.activeTabChange = index + 1 + "";
			this.changePages(index + 1 + "");
		}
	}
};
</script>
